var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mb-3" }, [
      _c("label", { staticClass: "d-none d-lg-block", attrs: { for: "" } }, [
        _vm._v(_vm._s(_vm._f("translate")("Notes"))),
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.note.content,
            expression: "note.content",
          },
        ],
        staticClass: "form-control",
        attrs: { rows: "10" },
        domProps: { value: _vm.note.content },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.note, "content", $event.target.value)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        class: {
          btn: true,
          "btn-sm": true,
          "px-4": true,
          "btn-dark": !_vm.working && !_vm.error && !_vm.success,
          "btn-secondary": _vm.working && !_vm.error && !_vm.success,
          "btn-success": !_vm.working && !_vm.error && _vm.success,
          "btn-danger": !_vm.working && _vm.error && !_vm.success,
        },
        attrs: { disabled: _vm.working || _vm.error || _vm.success },
        on: { click: _vm.submit },
      },
      [
        !_vm.working && !_vm.error && !_vm.success
          ? _c("span", [_vm._v(_vm._s(_vm._f("translate")("Save")))])
          : _vm._e(),
        _vm._v(" "),
        _vm.working && !_vm.error && !_vm.success
          ? _c("span", [
              _c("span", {
                staticClass: "spinner-border spinner-border-sm",
                attrs: { role: "status", "aria-hidden": "true" },
              }),
              _vm._v(" " + _vm._s(_vm._f("translate")("Saving"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.working && !_vm.error && _vm.success
          ? _c("span", [_vm._v(_vm._s(_vm._f("translate")("Saved")))])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }